import { connect } from "react-redux";
import NativeAppBanner from "./NativeAppBanner";
import {
  getStoreCode,
  getCountryCode
} from "../../state/modules/regionalStore";

function mapStateToProps(state) {
  return {
    welcomeMessage: state.welcomeMessage,
    storeCode: getStoreCode(state),
    countryCode: getCountryCode(state)
  };
}

export default connect(mapStateToProps)(NativeAppBanner);
